<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row align-items-end">
                <div class="col-md-9">
                  <div class="form-group mb-0">
                    <label>Фильтр: Группа</label>
                    <select class="form-control" v-model="filters.groupId" @change="fetchSchedules">
                      <option value="" disabled>Выберите группу</option>
                      <option v-for="g in groups" :key="g.id" :value="g.id">
                        {{ g.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-md-3 d-flex">
                  <button style="margin-right: 10px;" type="button" class="btn btn-info btn-fill" @click="fetchSchedules">
                    <i class="bx bx-refresh" style="font-size: 1.2rem; vertical-align: middle;"></i>
                  </button>
                  <router-link to="/admin/create-schedule" class="btn btn-success btn-fill ml-auto">
                    + Создать
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h4 class="card-title">Список занятий</h4>
            </div>

            <div class="card-body table-full-width table-responsive">
              <table class="table table-hover table-striped">
                <thead>
                <tr>
                  <th>Группа</th>
                  <th>Неделя</th>
                  <th>Предмет</th>
                  <th>Преподаватели</th>
                  <th>Аудитория / Ссылка</th> <th>Дата / Время</th>
                  <th class="text-right">Действия</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="fetching">
                  <td colspan="7" class="text-center">Загрузка данных...</td>
                </tr>
                <tr v-if="!fetching && schedules.length === 0">
                  <td colspan="7" class="text-center">
                    Нет записей по выбранным критериям
                  </td>
                </tr>

                <tr v-for="item in schedules" :key="item.id">
                  <td>{{ item.group ? item.group.name : ('ID: ' + item.groupId) }}</td>
                  <td>
                    <span :class="getWeekTypeBadgeClass(item.weekType)">
                      {{ getWeekTypeName(item.weekType) }}
                    </span>
                  </td>
                  <td>{{ item.subject ? item.subject.name : ('ID: ' + item.subjectId) }}</td>

                  <td>
                    <div v-if="item.tutors && item.tutors.length > 0">
                      <span v-for="(t, index) in item.tutors" :key="t.id">
                        {{ t.name }}<span v-if="index < item.tutors.length - 1">, </span>
                      </span>
                    </div>
                    <div v-else class="text-muted small">Нет назначенных</div>
                  </td>

                  <td>
                    <div v-if="item.isOnline">
                      <span class="badge badge-success mb-1">Онлайн</span>
                      <div v-if="item.link">
                        <a :href="item.link" target="_blank" style="font-size: 12px; text-decoration: underline;">
                          <i class="bx bx-link"></i> Ссылка
                        </a>
                      </div>
                      <small v-else class="text-muted d-block">Ссылка не указана</small>
                    </div>
                    <span v-if="item.roomId">
                      <i class="bx bxs-map" style="color: #ef4444;"></i>
                      {{ item.room ? item.room.uid : (item.roomId) }}
                    </span>
                  </td>

                  <td>
                    {{ getDayName(item.dayOfWeek) }}<br>
                    <small>{{ formatTime(item.startTime) }} - {{ formatTime(item.endTime) }}</small>
                  </td>
                  <td class="text-right">
                    <button class="btn btn-danger btn-sm btn-fill mr-1" @click="deleteSchedule(item.id)">
                      <i class='bx bx-trash'></i>
                    </button>
                    <button class="btn btn-warning btn-sm btn-fill" @click="openEditModal(item)">
                      <i class='bx bx-edit'></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showEditModal" class="modal-mask" @click.self="showEditModal = false">
        <div class="modal-wrapper">
          <div class="modal-container card">
            <div class="card-header">
              <h4 class="card-title">Редактировать занятие #{{ editForm.id }}</h4>
            </div>

            <div class="card-body">
              <form @submit.prevent="saveSchedule">
                <div class="row">
                  <div class="col-md-6 form-group">
                    <label>Тип занятия</label>
                    <select class="form-control" v-model="editForm.sessionType">
                      <option :value="2">Лекция</option>
                      <option :value="3">Практика</option>
                      <option :value="4">Лабораторная</option>
                      <option :value="5">Пересдача</option>
                      <option :value="6">Экзамен</option>
                      <option :value="7">Комиссия</option>
                      <option :value="8">Зачет</option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Формат проведения</label>
                    <select class="form-control" v-model="editForm.isOnline">
                      <option :value="false">Оффлайн (В аудитории)</option>
                      <option :value="true">Онлайн (Дистанционно)</option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>День недели</label>
                    <select class="form-control" v-model="editForm.dayOfWeek" required>
                      <option :value="1">Понедельник</option>
                      <option :value="2">Вторник</option>
                      <option :value="3">Среда</option>
                      <option :value="4">Четверг</option>
                      <option :value="5">Пятница</option>
                      <option :value="6">Суббота</option>
                      <option :value="7">Воскресенье</option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Периодичность (Неделя)</label>
                    <select class="form-control" v-model="editForm.weekType">
                      <option :value="1">Каждая неделя</option>
                      <option :value="2">Числитель (Верхняя)</option>
                      <option :value="3">Знаменатель (Нижняя)</option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Предмет</label>
                    <select class="form-control" v-model="editForm.subjectId">
                      <option v-for="s in subjects" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select>
                  </div>

                  <div class="col-md-12 form-group custom-dropdown-container">
                    <label>Преподаватели</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="tutorSearch"
                      @focus="activeDropdown = 'tutorEdit'"
                      placeholder="Поиск и добавление..."
                    >
                    <ul v-if="activeDropdown === 'tutorEdit'" class="custom-dropdown-list">
                      <li v-for="t in filteredEditTutors" :key="t.id" @mousedown="addTutorToEdit(t)">
                        {{ t.name }}
                      </li>
                      <li v-if="filteredEditTutors.length === 0" style="color: #999; cursor: default;">
                        Ничего не найдено или уже выбрано
                      </li>
                    </ul>

                    <div class="selected-items mt-2">
                      <span
                        v-for="(tutor, index) in editForm.selectedTutors"
                        :key="tutor.id"
                        class="badge badge-info mr-2 mb-1"
                        style="cursor: pointer;"
                        @click="removeTutorFromEdit(index)"
                      >
                        {{ tutor.name }} <span aria-hidden="true">&times;</span>
                      </span>
                    </div>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Группа</label>
                    <select class="form-control" v-model="editForm.groupId" disabled>
                      <option v-for="g in groups" :key="g.id" :value="g.id">
                        {{ g.name }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Аудитория</label>

                    <input
                      type="text"
                      class="form-control"
                      v-model="editForm.roomId"
                      placeholder="Номер аудитории"
                    >


                  </div>


                  <div class="col-md-12 form-group">
                    <label >Ссылка на занятие</label>

                    <input
                      type="text"
                      class="form-control"
                      v-model="editForm.link"
                      placeholder="https://zoom.us/..."
                    >
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Начало</label>
                    <input type="time" class="form-control" v-model="editForm.startTime" required>
                  </div>

                  <div class="col-md-6 form-group">
                    <label>Конец</label>
                    <input type="time" class="form-control" v-model="editForm.endTime" required>
                  </div>
                </div>

                <div class="text-right mt-3">
                  <button type="button" class="btn btn-secondary btn-fill mr-2" @click="showEditModal = false">Отмена</button>
                  <button type="submit" class="btn btn-info btn-fill">Сохранить</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '../server';

export default {
  name: 'ScheduleManager',
  data() {
    return {
      schedules: [],
      groups: [],
      subjects: [],
      tutors: [],

      filters: {
        groupId: '',
        tutorId: '',
        date: ''
      },

      fetching: false,
      showEditModal: false,
      activeDropdown: null,
      tutorSearch: '',

      editForm: {
        id: null,
        name: '',
        sessionType: 2,
        weekType: 1,
        selectedTutors: [],
        subjectId: 0,
        groupId: 0,
        roomId: '',
        link: '', // ADDED: Link field
        isOnline: false,
        date: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  watch: {
    // UPDATED: Clear irrelevant fields when switching mode
    'editForm.isOnline'(newVal) {
      if (newVal === true) {
        this.editForm.roomId = ''; // Clear room if online
      } else {
        this.editForm.link = '';   // Clear link if offline
      }
    }
  },
  computed: {
    filteredEditTutors() {
      const selectedIds = this.editForm.selectedTutors.map(t => t.id);
      return this.tutors.filter(t =>
        t.name.toLowerCase().includes(this.tutorSearch.toLowerCase()) &&
        !selectedIds.includes(t.id)
      );
    }
  },
  mounted() {
    this.loadDropdowns();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    handleClickOutside(e) {
      if (!e.target.closest('.custom-dropdown-container')) {
        this.activeDropdown = null;
      }
    },

    addTutorToEdit(tutor) {
      if (!this.editForm.selectedTutors.find(t => t.id === tutor.id)) {
        this.editForm.selectedTutors.push(tutor);
      }
      this.tutorSearch = '';
    },
    removeTutorFromEdit(index) {
      this.editForm.selectedTutors.splice(index, 1);
    },

    getTodayString() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    async loadDropdowns() {
      const token = localStorage.getItem('token');
      const headers = { 'Authorization': `Bearer ${token}` };

      try {
        const [groupRes, subjRes, tutorRes] = await Promise.all([
          axios.get(API_URL + '/api/group', { headers }),
          axios.get(API_URL + '/api/subject', { headers }),
          axios.get(API_URL + '/api/tutor', { headers })
        ]);

        if (groupRes.data.code === 200) {
          this.groups = groupRes.data.data;
          if (this.groups.length > 0) {
            this.filters.groupId = this.groups[0].id;
          }
        }

        this.filters.date = this.getTodayString();
        if (subjRes.data.code === 200) this.subjects = subjRes.data.data;
        if (tutorRes.data.code === 200) this.tutors = tutorRes.data.data;

        this.fetchSchedules();
      } catch (error) {
        console.error("Error loading dropdowns:", error);
      }
    },

    async fetchSchedules() {
      this.fetching = true;
      const token = localStorage.getItem('token');

      try {
        const response = await axios.get(
          API_URL + '/api/schedule/get-all',
          {
            headers: { Authorization: `Bearer ${token}` },
            params: {
              groupId: this.filters.groupId,
            }
          }
        );

        if (response.data.code === 200) {
          this.schedules = response.data.data || [];
        } else {
          this.schedules = [];
        }
      } catch (error) {
        console.error(error);
        this.schedules = [];
      } finally {
        this.fetching = false;
      }
    },

    async deleteSchedule(id) {
      if (!confirm("Вы уверены?")) return;
      const token = localStorage.getItem('token');
      try {
        await axios.delete(API_URL + `/api/schedule/${id}`, { headers: { 'Authorization': `Bearer ${token}` } });
        this.fetchSchedules();
      } catch (error) { console.error(error); }
    },

    openEditModal(item) {
      this.tutorSearch = '';
      this.editForm = {
        id: item.id,
        name: item.name,
        sessionType: item.sessionType,
        weekType: item.weekType || 1,
        dayOfWeek: item.dayOfWeek,
        selectedTutors: item.tutors ? [...item.tutors] : [],
        subjectId: item.subjectId,
        groupId: item.groupId,
        roomId: item.room ? item.room.uid : (item.roomId || ''),
        link: item.link || '', // ADDED: Map link from response
        isOnline: item.isOnline || false,
        date: item.date ? item.date.substring(0, 10) : '',
        startTime: item.startTime ? item.startTime.substring(0, 5) : '',
        endTime: item.endTime ? item.endTime.substring(0, 5) : ''
      };
      this.showEditModal = true;
    },

    async saveSchedule() {
      const token = localStorage.getItem('token');

      const payload = {
        name: this.editForm.name,
        sessionType: parseInt(this.editForm.sessionType),
        weekType: parseInt(this.editForm.weekType),
        dayOfWeek: parseInt(this.editForm.dayOfWeek),
        tutorIds: this.editForm.selectedTutors.map(t => t.id),
        subjectId: parseInt(this.editForm.subjectId),
        roomId: this.editForm.roomId ? this.editForm.roomId.toString() : '',
        link: this.editForm.link, // ADDED: Send link param
        isOnline: this.editForm.isOnline,
        startTime: this.editForm.startTime + ':00',
        endTime: this.editForm.endTime + ':00'
      };

      try {
        const response = await axios.put(`${API_URL}/api/schedule`, payload, {
          headers: { 'Authorization': `Bearer ${token}` },
          params: { scheduleId: this.editForm.id }
        });

        if (response.data.code === 200) {
          this.showEditModal = false;
          this.fetchSchedules();
        } else {
          alert("Ошибка: " + response.data.msg);
        }
      } catch (error) {
        console.error(error);
        alert("Ошибка соединения");
      }
    },

    getWeekTypeName(type) {
      const types = { 1: 'Каждая', 2: 'Верхняя', 3: 'Нижняя' };
      return types[type] || 'Неизвестно';
    },
    getWeekTypeBadgeClass(type) {
      if (type === 2) return 'badge badge-info';
      if (type === 3) return 'badge badge-warning';
      return 'badge badge-secondary';
    },
    getDayName(dayIndex) {
      const days = { 1: 'ПОНЕДЕЛЬНИК', 2: 'ВТОРНИК', 3: 'СРЕДА', 4: 'ЧЕТВЕРГ', 5: 'ПЯТНИЦА', 6: 'СУББОТА', 7: 'ВОСКРЕСЕНЬЕ' };
      return days[dayIndex] || 'НЕИЗВЕСТНО';
    },
    formatTime(timeStr) { return timeStr ? timeStr.substring(0, 5) : ''; }
  }
};
</script>

<style scoped>
.pagination-controls { display: flex; align-items: center; }
.mx-3 { margin-left: 1rem; margin-right: 1rem; }
.ml-auto { margin-left: auto; }
.mr-1 { margin-right: 0.25rem; }
.mr-2 { margin-right: 0.5rem; }

.badge {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 0.85rem;
  color: #fff;
}
.badge-info { background-color: #17a2b8; }
.badge-warning { background-color: #ffc107; color: #212529; }
.badge-secondary { background-color: #6c757d; }
.badge-success { background-color: #28a745; } /* Added for Online badge */

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper { width: 100%; max-width: 800px; padding: 20px; }
.modal-container { background-color: #fff; max-height: 90vh; overflow-y: auto; border-radius: 8px; }

/* Custom Dropdown Styles (Same as CreateSchedule) */
.custom-dropdown-container { position: relative; }
.custom-dropdown-list {
  position: absolute;
  top: 100%;
  left: 15px; /* Adjust for col padding */
  right: 15px;
  z-index: 1000;
  margin: 2px 0 0 0;
  padding: 5px 0;
  list-style: none;
  background-color: #fff; /* Changed to white for edit modal usually */
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}
.custom-dropdown-list li {
  padding: 8px 15px;
  color: #333;
  cursor: pointer;
  font-size: 14px;
}
.custom-dropdown-list li:hover { background-color: #f1f1f1; }
</style>
